export default __webpack_public_path__ + "static/13 - Biztosítéktábla-f705f7500b57a407622e09111babc5b4.jpg";